import React, { Component } from "react";
import { DomField, DomTextarea, DomBoolCheckbox } from "../Services/formDOM";
import "./Form.scss";
import { apiURL } from "../Services/Base";
import { checkInput, returnValue } from "../Services/Validation";
import Popup from "../Popup/Popup";
import Loading from "../Services/Loading/Loading";
import PopupMain from "../Popup/PopupMain";
import { GA_Push } from "../Services/GoogleAnalytics";

const throwPopupEvent = (obj) => {
    window.dispatchEvent(new CustomEvent("showpopup", {
        "detail": obj
    }));
}

const __Products__ = [
    {
        text: "פסטה/קוסקוס",
        className: "pasta"
    },
    {
        text: "<strong>ירק:</strong> כרובית, ברוקולי, כרוב, שעועית (אפשר גם עשבי תיבול)",
        className: "veg"
    },
    {
        text: "<strong>קטנית:</strong> חומוס, שעועית, אפונה",
        className: "kit"
    },
    {
        text: "<strong>גבינות מכל סוג, לדוגמה:</strong> בולגרית, מעושנת, גבינה לבנה, קוטג'",
        className: "chee"
    }
];

Object.filter = function (obj, predicate) {
    var result = {}, key;
    for (key in obj) {
        if (obj.hasOwnProperty(key) && predicate(obj[key])) {
            result[key] = obj[key];
        }
    }

    return result;
};

export default class Form extends Component {
    constructor() {
        super();
        this.addState = this.addState.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.setErrorMessage = this.setErrorMessage.bind(this);
        this.sendForm = this.sendForm.bind(this);
        this.state = {
            isLoading: false,
            isBusy: false
        }
    }
    componentDidMount() {
        window.addEventListener("changeState", (event) => {
            this.setState({
                isLoading: false,
                isBusy: false
            })
        })
    }
    addState(stateName, isRequired) {
        this.setState({
            [stateName]: {
                name: stateName,
                value: "",
                isRequired: !isRequired ? false : true
            }
        })
    }
    handleInputChange(event) {
        const handleChange = {
            [event.target.name]: {
                ...this.state[event.target.name],
                error: "",
                value: (event.target.dataset && event.target.dataset.bool === "true" ? (this.state[event.target.name].value ? 0 : 1) : event.target.value)
            }
        }
        this.setState(handleChange);
    }
    setErrorMessage(target, errorMsg) {
        if (!this.state[target.name]) return;

        this.setState({
            [target.name]: {
                ...target,
                error: errorMsg
            }
        });
    }
    async sendForm() {
        if (this.state.isBusy) return;

        this.setState({
            isLoading: true,
            isBusy: true
        });

        let isError = false,
            j = 0,
            jsonBody = {},
            state = Object.filter(this.state, s => s.isRequired),
            fieldStateKeys = Object.keys(state);

        for (let s in state) {
            if (await !checkInput(state[s], this.setErrorMessage)) isError = true;
            j++;
        }

        for (let k in fieldStateKeys) {
            jsonBody = Object.assign(jsonBody, {
                [fieldStateKeys[k]]: returnValue(state[fieldStateKeys[k]])
            });
        }

        if (isError && j == fieldStateKeys.length) {
            this.setState({
                isLoading: false,
                isBusy: false
            })
            return;
        }

        let isExists = await fetch(`${apiURL}IsExists`, {
            method: 'POST',
            headers: {
                'Content-Type': `application/json`
            },
            body: JSON.stringify(jsonBody)
        }).then(data => data.json());

        if (isExists) {
            throwPopupEvent({
                Type: "Message",
                ClassName: "success",
                refresh: false,
                Component: <Popup Context={`פרטים דומים רשומים כבר במאגר הנתונים`} />
            });
            return;
        }

        fetch(`${apiURL}Save`, {
            method: 'POST',
            headers: {
                'Content-Type': `application/json`
            },
            body: JSON.stringify(jsonBody)
        }).then(data => data.json())
            .then(data => {
                this.setState({
                    isLoading: false,
                    isBusy: false
                })
                GA_Push("Form_Sent");
                throwPopupEvent({
                    Type: "Message",
                    ClassName: "success",
                    refresh: true,
                    Component: <Popup Context={`פרטיך נשלחו בהצלחה!`} />
                });
            }).catch(error => {
                this.setState({
                    isLoading: false,
                    isBusy: false
                });
                throwPopupEvent({
                    Type: "Message",
                    ClassName: "success",
                    refresh: true,
                    Component: <Popup Context={`חלה שגיאה בעת שליחת הטופס`} />
                });
            });
    }
    render() {
        return (
            <section className="section section-form">
                <div className="container">
                    <div className="padding">
                        <Loading showLoading={this.state.isLoading} />
                        <PopupMain />
                        <div className="options">
                            <div className="products-headline">
                                הרכיבים:
                            </div>
                            <div className="products">
                                {__Products__.map((prod, index) => <InnerProd key={index} {...prod} />)}
                            </div>
                            <div className="note">
                                <div className="icon"></div>
                                <div className="text">
                                    <strong>ניתן להשתמש במוצרי יסוד:</strong> ביצים, שמן (מכל מיני סוגים), מלח, סוכר, תבלינים, עשבי תיבול
                                </div>
                            </div>
                        </div>
                        <div className="form">
                            <div className="yourrecpie">
                                המתכון שלכם:
                            </div>
                            <div className="fields">
                                <DomTextarea
                                    label="רשמו כאן את המתכון שלכם"
                                    placeholder="רשמו כאן את המתכון שלכם"
                                    name="Description"
                                    id="Description"
                                    isRequired
                                    onChange={this.handleInputChange}
                                    onLoad={this.addState}
                                    {...this.state} />
                                <div className="row">
                                    <DomField
                                        type="text"
                                        max={64}
                                        label="שם פרטי"
                                        placeholder="שם פרטי"
                                        name="FirstName"
                                        id="FirstName"
                                        isRequired
                                        onChange={this.handleInputChange}
                                        onLoad={this.addState}
                                        {...this.state} />
                                    <DomField
                                        type="text"
                                        max={64}
                                        label="שם משפחה"
                                        placeholder="שם משפחה"
                                        name="LastName"
                                        id="LastName"
                                        isRequired
                                        onChange={this.handleInputChange}
                                        onLoad={this.addState}
                                        {...this.state} />
                                </div>
                                <div className="row">
                                    <DomField
                                        type="tel"
                                        max={64}
                                        label="טלפון"
                                        placeholder="טלפון"
                                        name="PhoneNumber"
                                        id="PhoneNumber"
                                        isRequired
                                        onChange={this.handleInputChange}
                                        onLoad={this.addState}
                                        {...this.state} />
                                    <DomField
                                        type="email"
                                        max={64}
                                        label="מייל"
                                        placeholder="מייל"
                                        name="Email"
                                        id="Email"
                                        isRequired
                                        onChange={this.handleInputChange}
                                        onLoad={this.addState}
                                        {...this.state} />
                                </div>
                                <DomBoolCheckbox
                                    label={"מאשר שקראתי את <a href=\"http://z.ynet.co.il/mShort/commerce/2018/OsemRecipeAPI/takanon.htm\" target=\"_blank\">התקנון</a>"}
                                    type="checkbox"
                                    name="TOS"
                                    id="TOS"
                                    isRequired
                                    onChange={this.handleInputChange}
                                    onLoad={this.addState}
                                    {...this.state}
                                />
                                <div className="submit g-recaptcha" onClick={this.sendForm} data-sitekey="6LfoC3kUAAAAAPt8XZMzr6ljG2omdMJY7z8PPhpU">
                                    <div className="text">
                                        שליחה
                                    </div>
                                    <div className="arrow"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

const InnerProd = props => {
    return (
        <div className={`prod ${props.className}`}>
            <div className="icon"></div>
            <div className="text" dangerouslySetInnerHTML={{ __html: props.text }}></div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/Components/Form/Form.jsx